// extracted by mini-css-extract-plugin
module.exports = {"input":"RoundedCheckBox-module__input___lHq20","check":"RoundedCheckBox-module__check___2n8fQ","checked":"RoundedCheckBox-module__checked___2IwQC"};